import { generateActions } from "utils/generateActions";

export const ADD_WEBSITE = generateActions("ADD_WEBSITE");
export const GET_TABLE_WEBSITES = generateActions("GET_TABLE_WEBSITES");
export const MIGRATE_WEBSITES = generateActions("MIGRATE_WEBSITES");